/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { ProposalSummaryFeeDisinvestmentInstructionsBreakdown } from './ProposalSummaryFeeDisinvestmentInstructionsBreakdown';
import {
    ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSON,
    ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSONTyped,
    ProposalSummaryFeeDisinvestmentInstructionsBreakdownToJSON,
} from './ProposalSummaryFeeDisinvestmentInstructionsBreakdown';

/**
 * 
 * @export
 * @interface ProposalSummaryFeeDisinvestmentInstructions
 */
export interface ProposalSummaryFeeDisinvestmentInstructions {
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof ProposalSummaryFeeDisinvestmentInstructions
     */
    feeDisinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {Array<ProposalSummaryFeeDisinvestmentInstructionsBreakdown>}
     * @memberof ProposalSummaryFeeDisinvestmentInstructions
     */
    feeDisinvestmentInstructionsBreakdown: Array<ProposalSummaryFeeDisinvestmentInstructionsBreakdown>;
}

/**
 * Check if a given object implements the ProposalSummaryFeeDisinvestmentInstructions interface.
 */
export function instanceOfProposalSummaryFeeDisinvestmentInstructions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "feeDisinvestmentInstructionsBreakdown" in value;

    return isInstance;
}

export function ProposalSummaryFeeDisinvestmentInstructionsFromJSON(json: any): ProposalSummaryFeeDisinvestmentInstructions {
    return ProposalSummaryFeeDisinvestmentInstructionsFromJSONTyped(json, false);
}

export function ProposalSummaryFeeDisinvestmentInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryFeeDisinvestmentInstructions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feeDisinvestmentTypeId': !exists(json, 'FeeDisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['FeeDisinvestmentTypeId']),
        'feeDisinvestmentInstructionsBreakdown': ((json['FeeDisinvestmentInstructionsBreakdown'] as Array<any>).map(ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSON)),
    };
}

export function ProposalSummaryFeeDisinvestmentInstructionsToJSON(value?: ProposalSummaryFeeDisinvestmentInstructions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FeeDisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.feeDisinvestmentTypeId),
        'FeeDisinvestmentInstructionsBreakdown': ((value.feeDisinvestmentInstructionsBreakdown as Array<any>).map(ProposalSummaryFeeDisinvestmentInstructionsBreakdownToJSON)),
    };
}

